export default "__VITE_ASSET__CEXeytA5__"